import { h } from '@stencil/core';
const Subsection = ({ className = '' }, children) => {
  if (!children.length) {
    return null;
  }
  return h("div", { class: `area__subsection ${className}` }, children);
};
export default Subsection;
